module.exports = __webpack_public_path__ + "static/media/wallfinishes_lcs_60yd_y.f93b7a95.csv";